import { defineStore } from "pinia";
import { computed, onMounted, ref } from "vue";
import { GetAssetLabels } from "../services/AssetLabels/GetAssetLabels";

export const useUserDetailStore = defineStore("userDetail", () => {
  const userDetail = ref({
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    userTypeId: "",
    isDistributor: false,
    googleSheetLink: null,
    sheetName: null,
    earlyPayEligible: false,
  });
  const isAdmin = computed(() => {
    return userDetail.value.userTypeId == 1;
  });
  const isSuperAdmin = computed(() => {
    return userDetail.value.userTypeId == 4;
  });
  const isUser = computed(() => {
    return userDetail.value.userTypeId == 2 || userDetail.value.userTypeId == 3;
  });

  const assetLabels = ref([]);
  const fetchAssetLabel = async () => {
    try {
      const response = await GetAssetLabels(userDetail.value.id);
      if (response) {
        const filteredNames = response.data
          .filter((item) => item.assignedDashboard === 3)
          .map((item) => item.name);

        assetLabels.value = filteredNames;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const assetLabelString = computed(() => assetLabels.value.join(", "));

  onMounted(() => {
    fetchAssetLabel();
  });

  return {
    userDetail,
    isAdmin,
    isSuperAdmin,
    isUser,
    assetLabelString,
  };
});
